import "./projectComponent.css";


const ProjectComponent = ({img,link,title='my project '}) => {
  return (
    <div className="p">
      <div className="p-browser">
        <div className="p-circle-wrapper">
          <div style={{animationDelay:'0.3s'}}   className="p-circle"></div>
          <div style={{animationDelay:'0.6s'}}   className="p-circle"></div>
          <div style={{animationDelay:'0.9s'}}   className="p-circle"></div>
        </div>
        <p className="p-title">{title}</p>

      </div>
      <a href={link} target="_blank" rel="noreferrer">
        <img src={img} alt="" className="p-img" />
      </a>
    </div>
  );
};

export default ProjectComponent;
